import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
export const Clipboard = ({ size = 16, className = "text-gray-50", onClick, }) => {
    return (_jsxs("svg", { viewBox: "0 0 256 256", width: size, height: size, className: clsx("inline ml-1", { "cursor-pointer": !!onClick }, className), fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16", onClick: onClick, children: [_jsx("path", { d: "m216 184v-144h-144" }), _jsx("path", { d: "m40 72h144v144h-144z" })] }));
};
